import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminEngineSchema, adminHealthSchema, adminMicrosSchema, adminRecordedSchema, } from "./common.js";
import { adminUsageLineSchema } from "./usage.js";
/** The first page an operator sees: the answer to "does anything need a look?". */
export const adminOverviewSchema = z.object({
    asOf: z.string(),
    spend: z.object({
        monthToDateUsdMicros: adminMicrosSchema,
        budgetUsdMicros: adminMicrosSchema,
        projectedUsdMicros: adminMicrosSchema,
        daily: z.array(z.object({ day: adminDaySchema, usdMicros: adminMicrosSchema })),
    }),
    answers: z.object({
        day: adminDaySchema,
        expected: adminCountSchema,
        success: adminCountSchema,
        byEngine: z.array(z.object({
            engine: adminEngineSchema,
            expected: adminCountSchema,
            success: adminCountSchema,
        })),
    }),
    queue: z.object({
        waiting: adminCountSchema,
        oldestWaitingMinutes: adminCountSchema.nullable(),
        noOutcome: adminCountSchema,
    }),
    customers: z.object({
        workspaces: adminCountSchema,
        inSetup: adminCountSchema,
        active7d: adminRecordedSchema(adminCountSchema),
        dormantCapturing: adminRecordedSchema(adminCountSchema),
    }),
    services: z.array(z.object({ id: z.string(), label: z.string(), state: adminHealthSchema })),
    attention: z.array(z.object({
        id: z.string(),
        state: z.enum(["degraded", "down"]),
        title: z.string(),
        detail: z.string(),
        href: z.string(),
    })),
    usage: adminUsageLineSchema,
});
//# sourceMappingURL=overview.js.map